import { Spin } from "antd";

const Loading: React.FC = () => (
  <div style={{ 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center', 
    justifyContent: 'center', 
    height: '60vh',
    margin: '24px 40px'
  }}>
    <Spin size="large" />
    <div style={{ marginTop: '16px', color: '#666' }}>
      加载中...
    </div>
  </div>
);

export default Loading;
